import { createFileRoute } from '@tanstack/react-router'
import { IdentityConfig } from '~/features/webchat/components/IdentityConfig'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/identity')({
  component: Component,
})

function Component() {
  const { workspaceId, botId } = Route.useParams()

  return <IdentityConfig workspaceId={workspaceId} botId={botId} />
}
